module.exports = __webpack_public_path__ + "img/about-us.50ac85d3.png";